<div>
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">Perfiles</h2>
    </div>
    <div class="button-section">
      <!-- <div class="p-input-icon-left search-input">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt.filterGlobal($event.target.value, 'contains')"
            placeholder="Buscar..."
          />
        </span>
      </div> -->
      <button mat-flat-button class="btn-new" (click)="GoToAppPopGrafico()" appPermissionControl="P159B0001">
        <mat-icon>trending_up</mat-icon>
        Ingresar a perfiles óptimos
      </button>

      <!-- <button mat-raised-button color="accent" (click)="openCopiar()" style="margin-right: 10px;" appPermissionControl="P159B0002">
        <mat-icon>dns</mat-icon> Copiar
      </button> -->
      <!-- <button mat-raised-button color="accent" (click)="exportAsXLSX()" style="margin-right: 10px;">
        <mat-icon>trending_down</mat-icon> Exportar a Excel
      </button> -->
    </div>
  </div>
</div>

<!-- Estructura original del grid -->

<!-- <div id="div" class="mat-elevation-z8 table-responsive">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button (click)="openUpdate(element)" mat-menu-item>
            <mat-icon>edit</mat-icon>
            <span>Editar</span>
          </button>
          <button (click)="delete(element)" mat-menu-item>
            <mat-icon>delete</mat-icon>
            <span>Eliminar</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="clavePerfil">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Clave</th>
      <td mat-cell *matCellDef="let element">
        {{ element.clavePerfil }}
      </td>
    </ng-container>

    <ng-container matColumnDef="descripcion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Descripción</th>
      <td mat-cell *matCellDef="let element">
        {{ element.descripcion }}
      </td>
    </ng-container>

    <ng-container matColumnDef="scoreInicial">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Score Inicial</th>
      <td mat-cell *matCellDef="let element">
        {{ element.scoreInicial }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="20">
        <span *ngIf="allData > 0"
          >No hay resultados para "{{ input.value }}"</span
        >
        <span *ngIf="allData == 0 && !loading">No hay datos para mostrar</span>
        <mat-spinner *ngIf="loading" class="spinner"></mat-spinner>
      </td>
    </tr>
  </table>
  <mat-paginator
    [pageSizeOptions]="[5, 10, 20, 40, 80, allData]"
    showFirstLastButtons
    class="paginatorTb"
  ></mat-paginator>
</div> -->
